var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42004 2.44919C8.485 1.54343 7.23216 1.04117 5.93098 1.05044C4.62979 1.0597 3.38422 1.57976 2.46215 2.49875C1.54008 3.41774 1.01517 4.66225 1.00032 5.96461C0.985476 7.26698 1.48187 8.52315 2.38275 9.46296L9.97297 17L17.5632 9.4529C18.1175 8.89335 18.5306 8.20968 18.7685 7.4585C19.0063 6.70732 19.0619 5.91025 18.9307 5.13327C18.7995 4.3563 18.4853 3.62178 18.0141 2.99053C17.5429 2.35928 16.9283 1.84946 16.2211 1.50329C15.5452 1.16659 14.7995 0.994214 14.0445 1.00015C13.3901 0.999581 12.742 1.12916 12.138 1.38137C11.5339 1.63358 10.986 2.00338 10.5259 2.46932L9.97297 3.01271L9.42004 2.44919Z",
    fill: "#DF704D",
    stroke: "#77280C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.e7e34d800720c2b94c25f64751045232.svg";
export { ForwardRef as ReactComponent };